module.exports = __webpack_public_path__ + "static/img/blog_banner_mobile.d40749e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog_banner_mobile.png
// module id = VveK
// module chunks = 1